const ProductMenu = (props: { path: string; onPageChange: any }) => {
    const { path, onPageChange } = props;

    return (
        <div className="mt-4 sm:mt-0 flex gap-4 font-medium">
            <p
                className={`${
                    path === 'product' && 'underline'
                } cursor-pointer text-sm`}
                onClick={() => onPageChange('product')}
            >
                Produit
            </p>
            <p
                className={`${
                    path === 'stock' && 'underline'
                } cursor-pointer text-sm`}
                onClick={() => onPageChange('stock')}
            >
                {' '}
                Stock
            </p>
            <p
                className={`${
                    path === 'tech' && 'underline'
                } cursor-pointer text-sm`}
                onClick={() => onPageChange('tech')}
            >
                Technique
            </p>
            <p
                className={`${
                    path === 'perso' && 'underline'
                } cursor-pointer text-sm`}
                onClick={() => onPageChange('perso')}
            >
                Personnalisation
            </p>
            <p
                className={`${
                    path === 'shop-btob' && 'underline'
                } cursor-pointer text-sm`}
                onClick={() => onPageChange('shop-btob')}
            >
                Shop BtoB
            </p>
        </div>
    );
};

export default ProductMenu;
